export default __webpack_public_path__ + "static/PartnersCoop-2b96e91a71c77fc3d636fd7f2da6c2de.jpg";